import {
  DELETE_INBOX,
  GET_ALL_MAIL_INBOX,
  GET_MAIL_BOX,
  MOVE_CONVERSATION_TO,
  UPDATE_INBOX,
  UPDATE_SMTP_SETTINGS,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_MAIL_INBOX:
      return {
        ...state,
        inbox: action.payload,
      }

    case DELETE_INBOX: {
      return {
        ...state,
        data: action.payload,
      }
    }

    case GET_MAIL_BOX:
      return {
        ...state,
        getSingleInbox: action.payload,
        successData: action.successData,
      }

    case UPDATE_INBOX:
      return {
        ...state,
        updatedinbox: action.payload,
      }

    case MOVE_CONVERSATION_TO:
      return {
        ...state,
        moveConversationTo: action.payload,
      }

    case UPDATE_SMTP_SETTINGS: {
      return {
        smtpData: action.payload,
      }
    }

    default:
      return state
  }
}
